import RequestFeedback from "./ResponseFeedback";

const HttpFeedbackMap: { [p: string]: RequestFeedback } = {
  200: {
    severity: "success",
    errorCode: "success/ok",
    message: "Success",
  },
  201: {
    severity: "success",
    errorCode: "success/created",
    message: "Successfully created",
  },
  202: {
    severity: "success",
    errorCode: "success/accepted",
    message: "Successfully accepted",
  },
  400: {
    severity: "warning",
    errorCode: "client/bad-request",
    message: "Something went wrong",
  },
  401: {
    severity: "warning",
    errorCode: "client/unauthorized",
    message: "You do not have the proper permissions",
  },
  402: {
    severity: "warning",
    errorCode: "client/payment-required",
    message: "Payment is required",
  },
  403: {
    severity: "warning",
    errorCode: "client/forbidden",
    message: "You do not have permission for this action",
  },
  404: {
    severity: "warning",
    errorCode: "client/not-found",
    message: "Something was not found",
  },
  408: {
    severity: "error",
    errorCode: "client/request-timeout",
    message: "We could not connect to the server, please try again",
  },
  426: {
    severity: "warning",
    errorCode: "client/update-required",
    message: "Update required",
  },
  429: {
    severity: "warning",
    errorCode: "client/too-many-requests",
    message: "Too many actions",
  },
  451: {
    severity: "warning",
    errorCode: "client/unavailable-for-legal-reasons",
    message: "Not available for legal reasons",
  },
  500: {
    severity: "error",
    errorCode: "server/internal-server-error",
    message: "Server error",
  },
  501: {
    severity: "error",
    errorCode: "server/not-implemented",
    message: "Server error: Not implemented",
  },
  502: {
    severity: "error",
    errorCode: "server/bad-gateway",
    message: "Server error: Bad gateway",
  },
  503: {
    severity: "error",
    errorCode: "server/service-unavailable",
    message: "Service is unavailable",
  },
  504: {
    severity: "error",
    errorCode: "server/gateway-timeout",
    message: "Server timeout",
  },
  505: {
    severity: "error",
    errorCode: "server/http-version-not-supported",
    message: "Server error: HTTP version not supported",
  },
  511: {
    severity: "error",
    errorCode: "server/network-authentication-required",
    message: "Server error: Network authentication required",
  },
};

export default HttpFeedbackMap;
